export default function initApp() {
  const trigger = document.querySelector('#bookmark-btn');

  if (trigger) {
    trigger.addEventListener('click', () => {
      const url = trigger.dataset.url;
      const toast = document.querySelector('#toast');
      fetch(url, {
        method:
        'GET',
        credentials:
        'include',
      }).then(() => {
        toast.classList.add('show');
        setTimeout(() => toast.classList.remove('show'), 3000);
      });
    });
  }
}
